<template lang="html">
    <div id="prices-menu">
        <md-tabs :md-active-tab="activeTab">
            <md-tab id="tab-prices"   v-bind:to="{ name: 'Prices'}"         md-label="Список"></md-tab>
            <md-tab id="tab-settings" v-bind:to="{ name: 'PricesSettings'}" md-label="Настройки"></md-tab>
        </md-tabs>
    </div>
</template>
<script>
    export default {
        name: 'prices-menu',
        data() {
            return {
                activeTab: null
            }
        },
        watch: {
            '$route'() {
                this.activeTab = 'tab-' + this.$route.meta.tab;
            }
        },
        created() {
            this.activeTab = 'tab-' + this.$route.meta.tab;
        }
    }
</script>



// WEBPACK FOOTER //
// PricesMenu.vue?6a286bec